/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Auction } from '../models/auction';
import { AuctionWithRelations } from '../models/auction-with-relations';
import { editorCreateAuction } from '../fn/editor-auctions-controller/editor-create-auction';
import { EditorCreateAuction$Params } from '../fn/editor-auctions-controller/editor-create-auction';
import { editorDeleteAuction } from '../fn/editor-auctions-controller/editor-delete-auction';
import { EditorDeleteAuction$Params } from '../fn/editor-auctions-controller/editor-delete-auction';
import { editorGetAuction } from '../fn/editor-auctions-controller/editor-get-auction';
import { EditorGetAuction$Params } from '../fn/editor-auctions-controller/editor-get-auction';
import { editorGetAuctions } from '../fn/editor-auctions-controller/editor-get-auctions';
import { EditorGetAuctions$Params } from '../fn/editor-auctions-controller/editor-get-auctions';
import { editorUpdateAuction } from '../fn/editor-auctions-controller/editor-update-auction';
import { EditorUpdateAuction$Params } from '../fn/editor-auctions-controller/editor-update-auction';

@Injectable({ providedIn: 'root' })
export class EditorAuctionsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `auctionControllerEditorGetAuction()` */
  static readonly AuctionControllerEditorGetAuctionPath = '/editor/auctions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorGetAuction()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetAuction$Response(params: EditorGetAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionWithRelations>> {
    return editorGetAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorGetAuction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetAuction(params: EditorGetAuction$Params, context?: HttpContext): Observable<AuctionWithRelations> {
    return this.editorGetAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionWithRelations>): AuctionWithRelations => r.body)
    );
  }

  /** Path part for operation `auctionControllerEditorUpdateAuction()` */
  static readonly AuctionControllerEditorUpdateAuctionPath = '/editor/auctions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorUpdateAuction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editorUpdateAuction$Response(params: EditorUpdateAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return editorUpdateAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorUpdateAuction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editorUpdateAuction(params: EditorUpdateAuction$Params, context?: HttpContext): Observable<any> {
    return this.editorUpdateAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `auctionControllerEditorGetAuctions()` */
  static readonly AuctionControllerEditorGetAuctionsPath = '/editor/auctions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorGetAuctions()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetAuctions$Response(params?: EditorGetAuctions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuctionWithRelations>>> {
    return editorGetAuctions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorGetAuctions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetAuctions(params?: EditorGetAuctions$Params, context?: HttpContext): Observable<Array<AuctionWithRelations>> {
    return this.editorGetAuctions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AuctionWithRelations>>): Array<AuctionWithRelations> => r.body)
    );
  }

  /** Path part for operation `auctionControllerEditorCreateAuction()` */
  static readonly AuctionControllerEditorCreateAuctionPath = '/editor/auctions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorCreateAuction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editorCreateAuction$Response(params?: EditorCreateAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<Auction>> {
    return editorCreateAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorCreateAuction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editorCreateAuction(params?: EditorCreateAuction$Params, context?: HttpContext): Observable<Auction> {
    return this.editorCreateAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<Auction>): Auction => r.body)
    );
  }

  /** Path part for operation `auctionControllerEditorDeleteAuction()` */
  static readonly AuctionControllerEditorDeleteAuctionPath = '/editor/auctions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorDeleteAuction()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorDeleteAuction$Response(params: EditorDeleteAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return editorDeleteAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorDeleteAuction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorDeleteAuction(params: EditorDeleteAuction$Params, context?: HttpContext): Observable<any> {
    return this.editorDeleteAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
